"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _CollapsedAssetMetadata = _interopRequireDefault(require("./CollapsedAssetMetadata"));
var _ExpandedAssetMetadata = _interopRequireDefault(require("./ExpandedAssetMetadata"));
var _EditButton = _interopRequireDefault(require("./EditActions/EditButton/EditButton"));
var _SaveButton = _interopRequireDefault(require("./EditActions/SaveButton/SaveButton"));
var _CloseButton = _interopRequireDefault(require("./EditActions/CloseButton/CloseButton"));
var _events = require("./events");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "asset-metadata": "AssetMetadata__asset-metadata__FR6Rb",
  "assetMetadata": "AssetMetadata__asset-metadata__FR6Rb",
  "expanded-asset-metadata": "AssetMetadata__expanded-asset-metadata__2hM1A",
  "expandedAssetMetadata": "AssetMetadata__expanded-asset-metadata__2hM1A",
  "column-asset-metadata": "AssetMetadata__column-asset-metadata__35gIZ",
  "columnAssetMetadata": "AssetMetadata__column-asset-metadata__35gIZ",
  "collapsed-asset-metadata": "AssetMetadata__collapsed-asset-metadata__ikOgJ",
  "collapsedAssetMetadata": "AssetMetadata__collapsed-asset-metadata__ikOgJ",
  "header": "AssetMetadata__header__3ZIcV",
  "asset-metadata-container": "AssetMetadata__asset-metadata-container__13g4r",
  "assetMetadataContainer": "AssetMetadata__asset-metadata-container__13g4r",
  "minor-version": "AssetMetadata__minor-version__1-00E",
  "minorVersion": "AssetMetadata__minor-version__1-00E",
  "change-view": "AssetMetadata__change-view__2XOII",
  "changeView": "AssetMetadata__change-view__2XOII",
  "hr": "AssetMetadata__hr__38xc1",
  "header-margin": "AssetMetadata__header-margin__297tX",
  "headerMargin": "AssetMetadata__header-margin__297tX",
  "header-info": "AssetMetadata__header-info__3uTjl",
  "headerInfo": "AssetMetadata__header-info__3uTjl",
  "header-row": "AssetMetadata__header-row__dTOt0",
  "headerRow": "AssetMetadata__header-row__dTOt0",
  "edit-buttons": "AssetMetadata__edit-buttons__XdeWi",
  "editButtons": "AssetMetadata__edit-buttons__XdeWi"
}; 
require('./AssetMetadata.css');
var AssetMetadata = function AssetMetadata(_ref) {
  var asset = _ref.asset,
    canEdit = _ref.canEdit,
    isLoading = _ref.isLoading,
    _ref$onSaveChanges = _ref.onSaveChanges,
    onSaveChanges = _ref$onSaveChanges === void 0 ? /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })) : _ref$onSaveChanges;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    toggleViewPressed = _useState4[0],
    setToggleViewPressed = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    assetFieldValues = _useState6[0],
    setAssetFieldValues = _useState6[1];
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var onEditField = function onEditField(_ref3, options) {
    var fieldName = _ref3.fieldName,
      fieldValue = _ref3.value,
      isValid = _ref3.isValid;
    var type = options === null || options === void 0 ? void 0 : options.type;
    var value = fieldValue ? fieldValue.trim() : fieldValue;
    setAssetFieldValues(_objectSpread(_objectSpread({}, assetFieldValues), {}, (0, _defineProperty2.default)({}, fieldName, {
      value: value,
      type: type,
      isValid: isValid !== null && isValid !== void 0 ? isValid : true
    })));
  };
  var onToggleView = function onToggleView() {
    trackEvent(isExpanded ? _events.EVENT_TYPES.COLLAPSE_MINOR_VERSION_SECTION : _events.EVENT_TYPES.EXPAND_MINOR_VERSION_SECTION);
    setIsExpanded(!isExpanded);
    setToggleViewPressed(true);
  };
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    isEditing = _useState8[0],
    setIsEditing = _useState8[1];
  var renderEditButtons = function renderEditButtons() {
    if (!canEdit) {
      return null;
    }
    if (isEditing || isLoading) {
      var onSaveClick = function onSaveClick() {
        var isFormValid = Object.keys(assetFieldValues).every(function (key) {
          return assetFieldValues[key].isValid;
        });
        if (isFormValid) {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          onSaveChanges(assetFieldValues);
          setIsEditing(false);
        }
      };
      var onCloseClick = function onCloseClick() {
        setAssetFieldValues({});
        setIsEditing(false);
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.editButtons
      }, /*#__PURE__*/_react.default.createElement(_SaveButton.default, {
        isDisabled: isLoading,
        onClick: onSaveClick
      }), /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
        isDisabled: isLoading,
        onClick: onCloseClick
      }));
    }
    var onEditClick = function onEditClick() {
      setIsEditing(true);
      setIsExpanded(true);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.editButtons
    }, /*#__PURE__*/_react.default.createElement(_EditButton.default, {
      onClick: onEditClick
    }));
  };
  var AssetMetadataComponent = isExpanded ? _ExpandedAssetMetadata.default : _CollapsedAssetMetadata.default;
  (0, _react.useEffect)(function () {
    if (toggleViewPressed) {
      setToggleViewPressed(false);
    }
  }, [toggleViewPressed]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "asset-metadata-container",
    className: styles.assetMetadata
  }, /*#__PURE__*/_react.default.createElement(AssetMetadataComponent, {
    asset: asset,
    onEditField: onEditField,
    isLoading: isLoading,
    onToggleView: onToggleView,
    renderEditButtons: renderEditButtons,
    isEditing: isEditing,
    isToggleViewButtonFocused: toggleViewPressed
  }), /*#__PURE__*/_react.default.createElement("hr", {
    className: styles.hr
  }));
};
var _default = exports.default = AssetMetadata;
//# sourceMappingURL=AssetMetadata.js.map